import { Box, Typography } from "@mui/material";
import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

export const DonutChart: React.FC<{ data: { value: number, label: string, color: string, legendLabel: string; legendValue: string }[] }> = ({ data }) => {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" height={'100%'}>
            <Box sx={{ width: "50%", height: '100%', overflow: 'hidden' }}>
                <ResponsiveContainer>
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={100}
                            labelLine={false}
                            dataKey="value"
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                        <Tooltip
                            formatter={(_value, _name, props) => {
                                const payload = props?.payload;
                                return [payload.legendLabel];
                            }}
                            contentStyle={{
                                fontSize: 12,
                                borderRadius: 8,
                                backgroundColor: "#fafafa",
                                border: "1px solid #ddd",
                            }}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </Box>
            <Box sx={{ width: "50%", height: '100%', overflowY: 'hidden' }} display="flex" flexDirection="column" justifyContent="center">
                <Box height={'85%'} mr={2} sx={{ overflowY: "auto", display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    {data.map((item, key: number) => (
                        <Box key={key} display="flex" alignItems="center" mb={0.8} gap={1}>
                            <Box
                                sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: "50%",
                                    bgcolor: item.color,
                                }}
                            />
                            <Typography variant="caption" color="text.primary">
                                {item.label} :
                            </Typography>
                            <Typography
                                variant="caption"
                                color="text.primary"
                                fontWeight={500}
                            >
                                {item.legendValue}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );

};